(function () {
  const initMediaWithTextSlideshow = (section) => {
    const slideshow = section.querySelector('slideshow-component');
    if (!slideshow) return;

    const prevButton = section.querySelector('.media-with-text-slideshow__arrow--prev');
    const nextButton = section.querySelector('.media-with-text-slideshow__arrow--next');
    if (!prevButton || !nextButton) return;

    const attachNavigation = () => {
      const slider = slideshow.sliderInstance && slideshow.sliderInstance.slider;
      if (!slider) return false;

      prevButton.addEventListener('click', () => slider.slidePrev());
      nextButton.addEventListener('click', () => slider.slideNext());
      return true;
    };

    if (attachNavigation()) return;

    const observer = new MutationObserver(() => {
      if (attachNavigation()) observer.disconnect();
    });

    observer.observe(slideshow, {
      attributes: true,
      attributeFilter: ['data-media-loading'],
    });
  };

  document.querySelectorAll('.media-with-text-slideshow').forEach(initMediaWithTextSlideshow);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.media-with-text-slideshow') || event.target;
    if (section.classList && section.classList.contains('media-with-text-slideshow')) {
      initMediaWithTextSlideshow(section);
    }
  });
})();
